import React from "react";
import dayjs from "dayjs";
import { AuditTradeItemClass, AuditTxn, Txn } from "@moonscape/shared";
import { AuditTradeItemSmall } from "./AuditTradeItemSmall";

import { AuditTradeItemMedium } from "./AuditTradeItemMedium";
import { CheckMark, Lab } from "@/components/ms";
import { LedgerFullRow } from "./ledgerTable";
import { AUDIT_COLS } from "./AuditTradeItemMedium";

export { AUDIT_COLS };

const utc = require("dayjs/plugin/utc");
dayjs.extend(utc);

type Props = {
  txn?: Txn | AuditTxn;
  showBorderBottom?: boolean;
  screen: string;
  isEmpty?: boolean;
  text?: string;
  userId?: string;
  side?: string;
  id?: string;
  isQueryLoading: boolean;
};

export const AuditTradeItem: React.FC<Props> = ({
  txn,
  screen, // if screen is sm for breakpoints
  isEmpty = false,
  isQueryLoading,
  text,
  userId,
  side,
  id,
}) => {
  const t = new AuditTradeItemClass(txn);

  const EmptyStateText = () => (
    <div className="flex flex-col items-center justify-center gap-2 p-10 text-center">
      <CheckMark size={18} className="text-ms-green" />
      <h2 className="text-[17px] font-semibold tracking-[-0.02em] text-ms-ink">
        You're all caught up
      </h2>
      <Lab className="text-ms-dim">Nothing needs your attention right now</Lab>
    </div>
  );

  if (!isQueryLoading) {
    // empty state - no results
    if (isEmpty) {
      if (screen === "sm") {
        return (
          // sm screen
          <div className="flex-1 px-4 py-2 text-left">
            <EmptyStateText />
          </div>
        );
        // md screen
      } else if (screen === "md") {
        return (
          <LedgerFullRow span={AUDIT_COLS.length}>
            <EmptyStateText />
          </LedgerFullRow>
        );
      }
    }
  }

  // for sm screen
  if (screen === "sm") {
    return <AuditTradeItemSmall t={t} isQueryLoading={isQueryLoading} />;
  } else {
    // for 'md' and larger screens
    return <AuditTradeItemMedium t={t} isQueryLoading={isQueryLoading} />;
  }
};
